import { Languages } from "lucide-react";
import { useNavigate, useLocation } from "react-router-dom";
import { useLocaleContext } from "@/i18n/LocaleContext";
import { useT } from "@/i18n/useT";
import { SUPPORTED_LOCALES, LOCALE_LABELS, localePath, stripLocale, type Locale } from "@/i18n/locales";
import {
  DropdownMenu,
  DropdownMenuTrigger,
  DropdownMenuContent,
  DropdownMenuItem,
} from "@/components/ui/dropdown-menu";

export default function LanguageSelector() {
  const locale = useLocaleContext();
  const { t } = useT();
  const navigate = useNavigate();
  const location = useLocation();

  const pathWithoutLocale = stripLocale(location.pathname);

  function switchTo(target: Locale) {
    if (target === locale) return;
    navigate(localePath(target, pathWithoutLocale));
  }

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button
          className="p-1.5 rounded-md text-muted-foreground/60 hover:text-foreground transition-colors"
          aria-label={t("languageSelector")}
        >
          <Languages size={15} strokeWidth={1.5} />
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="min-w-[130px]">
        {SUPPORTED_LOCALES.map((loc) => (
          <DropdownMenuItem
            key={loc}
            onClick={() => switchTo(loc)}
            className={loc === locale ? "font-semibold text-foreground" : "text-muted-foreground"}
          >
            {LOCALE_LABELS[loc]}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
